"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewZapierWebhook extends new_item_1.default {
    constructor(newZapierWebhook) {
        super();
        this.body = newZapierWebhook.body;
    }
}
exports.default = NewZapierWebhook;
//# sourceMappingURL=new-zapierWebhook.js.map